import React from 'react';

import {GenericPaginatedList} from 'app/components/general/lists/GenericPaginatedList';
import {CompactProcessListItem} from 'app/process/components/CompactProcessListItem';
import {StoredProcessesFetcher} from 'app/process/datafetchers';
import {useRemoveTeamItem} from 'app/teams/api';
import {
  type ListItemProps,
  TeamListItem,
} from 'app/teams/components/TeamDetailPage/components/TeamListItem';
import {TeamPageFilterBarStructure} from 'app/teams/components/TeamDetailPage/components/TeamPageFilterBarStructure';
import {gt} from 'app/utils/i18n';

import {AddNewTeamProcessButton} from './AddNewTeamProcessButton';

import type {ProcessSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  onFetch: () => unknown;
};

type ProcessListItemProps = ListItemProps<ProcessSerializedType> & {
  team: TeamSerializedType;
};

export const TeamProcessesSubPage = ({team}: Props) => {
  const [removeTeamItem] = useRemoveTeamItem();

  return (
    <div>
      {team.can_edit ? (
        <TeamPageFilterBarStructure>
          <div className="col-auto ml-auto">
            <AddNewTeamProcessButton team={team} />
          </div>
        </TeamPageFilterBarStructure>
      ) : null}

      <GenericPaginatedList
        ItemComponent={ProcessListItem}
        FetcherComponent={StoredProcessesFetcher}
        noItemsMessage={(perms, NoResultsMessage) => (
          <NoResultsMessage head={gt('No processes for this team')}>
            <AddNewTeamProcessButton
              buttonClass="btn btn-outline-primary"
              placement="top"
              team={team}
            />
          </NoResultsMessage>
        )}
        paramsBuilder={() => ({
          team_id: team.id,
          ordering: 'name',
        })}
        customProps={() => ({
          team,
        })}
        customDispatchProps={() => ({
          remove: (team: TeamSerializedType, process: ProcessSerializedType) =>
            removeTeamItem({teamURL: team.url, item: process}),
        })}
      />
    </div>
  );
};

const ProcessListItem = ({
  object,
  team,
  remove,
  refetchList,
}: ProcessListItemProps) => (
  <TeamListItem
    object={object}
    team={team}
    remove={remove}
    contentType={'process'}
    ListItem={CompactProcessListItem}
    refetchList={refetchList}
  />
);
